export default "__VITE_ASSET__CRNdx3Ec__"